/* Header search: the magnifier icon opens/closes a full-width search bar. */
(function () {
  var OPEN = 'frm-search-open';
  function header() { return document.querySelector('theme-header.header') || document.querySelector('.header'); }
  function setOpen(open) {
    var h = header();
    if (!h) return;
    h.classList.toggle(OPEN, open);
    if (open) {
      var input = document.getElementById('header-search-input');
      if (input) { input.focus(); }
    }
  }
  document.addEventListener('click', function (e) {
    var h = header();
    if (!h) return;
    var icon = e.target.closest && e.target.closest('.thb-secondary-search');
    if (icon) {
      e.preventDefault();
      e.stopPropagation();
      setOpen(!h.classList.contains(OPEN));
      return;
    }
    if (h.classList.contains(OPEN) && !(e.target.closest && e.target.closest('.searchform'))) setOpen(false);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setOpen(false);
  });
})();
